<template>
    <div>
        <CCard class="w-100">
            <CCardHeader>
                <h2>{{FormType}} Invoice Uang Muka : {{InvoiceCode}}</h2>
            </CCardHeader>
            <CCardBody>
                <div class="px-3">
                    <CRow>
                        <div class="col-sm-half">
                            <div class="row px-3">
                                <div style="width: 31%;">
                                    <label class="form-label font-weight-bold required">Nomor Invoice</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div style="width: 8%;">
                                </div>
                                <div style="width: 61%;">
                                    <CInput id="InvoiceCode" v-model="InvoiceCode" class="font-weight-bold" />
                                    <label id="errorInvoiceCode" class="form-error pb-2" style="display: none; color: red;"></label>
                                </div>  
                            </div>
                            <div class="row px-3">
                                <div style="width: 31%;">
                                    <label class="form-label font-weight-bold">Status</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div style="width: 8%;">
                                </div>
                                <div style="width: 61%;">
                                    <CSelect id="Status" class="font-weight-bold" :options="StatusData" :value.sync="Status" />
                                    <label id="errorStatus" class="form-error" style="display: none; color: red;"></label>
                                </div>  
                            </div>
                            <div class="row px-3">
                                <div style="width: 31%;">
                                    <label class="form-label font-weight-bold">Note</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div style="width: 8%;">
                                </div>
                                <div style="width: 61%;">
                                    <CInput id="Note" v-model="Note" class="font-weight-bold"/>
                                    <label id="errorNote" class="form-error pb-2" style="display: none; color: red;"></label>
                                </div>  
                            </div>
                            <div class="row px-3">
                                <div style="width: 31%;">
                                    <label class="form-label font-weight-bold required">Customer</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div style="width: 8%;">
                                </div>
                                <div style="width: 61%;">
                                    <v-select id="Customer" class="pb-3" :options="CustomerData" v-model="Customer" @input="onChangeCustomer()" :disabled="DisabledCustomerInput ? false : true" />
                                    <label id="errorCustomer" class="form-error pb-2" style="display: none; color: red;"></label>
                                </div>  
                            </div>
                            <div class="row px-3">
                                <div style="width: 31%;">
                                    <label class="form-label font-weight-bold required">Project</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div style="width: 8%;">
                                </div>
                                <div style="width: 61%;">
                                    <v-select id="Project" class="pb-3" :options="ProjectData" v-model="Project" @input="onChangeProject()" :disabled="DisabledInput ? false : true"/>
                                    <label id="errorProject" class="form-error pb-2" style="display: none; color: red;"></label>
                                </div>  
                            </div>
                        </div>
                        <div class="col-sm-half px-3">
                            <div class="p-3 border rounded">
                                <label class="form-label font-weight-bold">Informasi Customer</label>
                                <hr>
                                <CRow>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Deposit</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{Deposit}}</label>
                                    </div>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Limit PO</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{LimitPO}}</label>
                                    </div>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">PO (Non-Cash)</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{PONonCash}}</label>
                                    </div>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Payment (Non-Cash)</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{Payment}}</label>
                                    </div>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Outstanding (Non-Cash)</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{Outstanding}}</label>
                                    </div>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Sisa Limit</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{RemainingLimit}}</label>
                                    </div>
                                </CRow>
                            </div>
                        </div>
                        <div class="col-sm-half px-3">
                            <div class="p-3 border rounded">
                                <label class="form-label font-weight-bold">Informasi {{Type}}</label>
                                <hr>
                                <CRow>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Forecast</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{ProjectForecastType}}</label>
                                    </div>
                                </CRow>
                                <CRow>
                                    <div class="col-sm-7">
                                        <label class="form-label font-weight-bold">Salesman</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-sm-5">
                                        <label class="form-label font-weight-bold" style="float:right">{{ProjectSalesman}}</label>
                                    </div>
                                </CRow>
                            </div>
                        </div>
                    </CRow>
                    <CRow class="pt-3" >
                        <div class="p-3 border rounded" style="width: 100%;">
                            <label class="form-label font-weight-bold" style="margin-bottom: 0px"><h4>Item</h4></label>
                            <hr>

                            <datasource ref="itemDataSource" :data="this.ItemGridData" :page-size="10" :schema-model-fields="this.ItemSchemaModel"/>

                            <kendo-grid ref="gridItem"
                                        :data-source-ref="'itemDataSource'"
                                        :editable="EditableValue"
                                        :filterable="true"
                                        :sortable="true"
                                        :pageable="true"
                                        :resizable="true"
                                        :cellClose="itemCellClose">
                                <kendo-grid-column  :field="'product_code'"
                                                    :title="'Kode'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'item_name'"
                                                    :title="'Nama'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'price'"
                                                    :title="'Harga'"
                                                    :format="'{0:N0}'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'price_discount'"
                                                    :title="'Diskon'"
                                                    :format="'{0:N0}'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'net'"
                                                    :title="'Net'"
                                                    :format="'{0:N0}'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'qty'"
                                                    :title="'Quantity'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'real_qty'"
                                                    :title="'Base Quantity'"
                                                    :format="'{0:N0}'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'total_price'"
                                                    :title="'Total'"
                                                    :format="'{0:N0}'"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'discount1'"
                                                    :title="'Diskon 1'"
                                                    :template="disc1Template"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'discount2'"
                                                    :title="'Diskon 2'"
                                                    :template="disc2Template"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'discount3'"
                                                    :title="'Diskon 3'"
                                                    :template="disc3Template"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'discount4'"
                                                    :title="'Diskon 4'"
                                                    :template="disc4Template"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'discount5'"
                                                    :title="'Diskon 5'"
                                                    :template="disc5Template"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                <kendo-grid-column  :field="'discount_cash'"
                                                    :title="'Diskon Cash'"
                                                    :template="disccashTemplate"
                                                    :width="150"
                                                    :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                    :attributes="{ style: 'text-align:right' }"></kendo-grid-column>
                            </kendo-grid>
                        </div>
                    </CRow>
                    <hr>
                    <CRow>
                        <div class="col-7">
                            <div class="p-3 border rounded" style="width: 100%;" v-if="this.FormType == 'Edit'">
                                <div>
                                    <!-- DownPayment Grid -->
                                    <label class="form-label font-weight-bold" style="margin-bottom: 0px"><h4>Down Payment</h4></label>
                                    <button class="btn btn-primary float-right"
                                        @click="addDownPaymentClick()" v-if="this.Status == 'New'">
                                        <i class="fa fa-plus"></i> Add
                                    </button>
                                    <hr>

                                    <datasource ref="downPaymentDataSource" :data="this.DownPaymentGridData" :page-size="10" :schema-model-fields="this.DownPaymentSchemaModel"/>

                                    <kendo-grid ref="gridDownPayment"
                                                :data-source-ref="'downPaymentDataSource'"
                                                :editable="false"
                                                :filterable="true"
                                                :sortable="true"
                                                :pageable="true"
                                                :resizable="true">

                                        <kendo-grid-column  :field="'date'"
                                                            :title="'Tanggal'"
                                                            :width = "150"
                                                            :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                            :attributes="{style: 'text-align:center'}"
                                                            :template="this.dateFormat"></kendo-grid-column>

                                        <kendo-grid-column  :field="'amount'"
                                                            :title="'Uang Muka'"
                                                            :format="'{0:N0}'"
                                                            :width="150"
                                                            :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"
                                                            :attributes="{ style: 'text-align:right' }"></kendo-grid-column>

                                        <kendo-grid-column  :field="'notes'"
                                                            :title="'Catatan'"
                                                            :width="150"
                                                            :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"></kendo-grid-column>

                                        <kendo-grid-column  :field="'created_by'"
                                                            :title="'Dibuat Oleh'"
                                                            :width="150"
                                                            :headerAttributes="{ style: 'text-align:center; font-weight:bold;' }"></kendo-grid-column>
                                    </kendo-grid>

                                    <down-payment-event-form ref="downPaymentEventForm" :saveDownPaymentGrid="saveDownPaymentGrid"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-5">
                            <CRow class="pb-3">
                                <div class="col-5">
                                    <label class="form-label font-weight-bold">Total Gross</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div class="col-7">
                                    <input type="number" id="TotalGross" v-model="TotalGross" class="font-weight-bold form-control input-number" readonly/>
                                </div> 
                            </CRow>
                            <CRow class="pb-3">
                                <div class="col-5">
                                    <label class="form-label font-weight-bold">Total Disc (-)</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div class="col-7">
                                    <input type="number" id="TotalDisc" v-model="TotalDisc" class="font-weight-bold form-control input-number" readonly/>
                                </div> 
                            </CRow>
                            <CRow>
                                <div class="col-5">
                                    <label class="form-label font-weight-bold">Pajak PPN (%)</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div class="col-7">
                                    <CSelect id="PPNTax" class="font-weight-bold" :options="PPNTaxData" :value.sync="PPNTax" @change="onChangePPNTax()"/>
                                    <label id="errorPPNTax" class="form-error pb-2" style="display: none; color: red;"></label>
                                </div> 
                            </CRow>
                            <CRow class="pb-3">
                                <div class="col-5">
                                    <label class="form-label font-weight-bold">Pajak PPN {{PPNTax}}%</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div class="col-7">
                                    <input type="number" id="TotalPPNTax" v-model="TotalPPNTax" class="font-weight-bold form-control input-number" readonly/>
                                </div>
                            </CRow>
                            <CRow>
                                <div class="col-5">
                                    <label class="form-label font-weight-bold">Grand Total</label>
                                    <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                </div>
                                <div class="col-7">
                                    <input type="number" id="GrandTotal" v-model="GrandTotal" class="font-weight-bold form-control input-number" readonly/>
                                </div> 
                            </CRow>
                            <div v-if="this.FormType == 'Add'">
                                <hr>
                                <CRow class="pb-3">
                                    <div class="col-5">
                                        <label class="form-label font-weight-bold required">Uang Muka</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-7">
                                        <input type="number" id="DownPayment" v-model="DownPayment" class="font-weight-bold form-control input-number" min="0"/>
                                        <label id="errorDownPayment" class="form-error pb-2" style="display: none; color: red;"></label>
                                    </div> 
                                </CRow>
                                <CRow class="pb-3">
                                    <div class="col-5">
                                        <label class="form-label font-weight-bold required">Tanggal Uang Muka</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-7">
                                        <date-picker
                                            v-model="DownPaymentDate"
                                            format="DD MMM YYYY"
                                            type="date"
                                            placeholder="Select date"
                                            value-type="YYYY-MM-DD"
                                            style="width:100%"
                                            :disabled="DisabledInput ? false : true"
                                        ></date-picker>
                                        <label id="errorDownPaymentDate" class="form-error pb-2" style="display: none; color: red;"></label>
                                    </div> 
                                </CRow>
                                <CRow>
                                    <div class="col-5">
                                        <label class="form-label font-weight-bold">Catatan Uang Muka</label>
                                        <label class="form-label font-weight-bold" style="float:right">:&nbsp;</label>
                                    </div>
                                    <div class="col-7">
                                        <CInput id="DownPaymentNote" v-model="DownPaymentNote" class="font-weight-bold"/>
                                        <label id="errorDownPaymentNote" class="form-error pb-2" style="display: none; color: red;"></label>
                                    </div> 
                                </CRow>
                            </div>
                        </div>
                    </CRow>
                    <br>
                    <CButton type="button" @click="saveClick()" class="save-button" id="saveButton" color="success" style="float: right;"> Save </CButton>
                    <label style="float: right;">&nbsp;&nbsp;</label>
                    <CButton type="button" color="secondary" style="float: right;" data-bs-dismiss="modal" aria-label="Close" @click="$router.push('/invoice-uang-muka')"> Close </CButton>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { globalfunc } from '../../../../shared/GlobalFunction.js';
import invoiceDownPaymentService from '../Script/InvoiceDownPaymentScript.js';
import { Grid, GridColumn} from '@progress/kendo-grid-vue-wrapper';
import { DataSource } from '@progress/kendo-datasource-vue-wrapper';
import { response } from '../../../../infrastructure/constant/response';
import { sweet_alert } from '../../../../infrastructure/constant/variable';
import datePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import { baseUrl } from '../../../../infrastructure/constant/connection';

//Form
import ItemProjectForm from './ItemProjectForm.vue';
import DownPaymentEventForm from './DownPaymentEventForm.vue';

export default {
    name: 'InvoiceDownPaymentFormPage',
    components: {
        'date-picker' : datePicker,
        'kendo-grid' : Grid,
        'kendo-grid-column': GridColumn,
        'datasource' : DataSource,
        'item-project-form' : ItemProjectForm,
        'down-payment-event-form' : DownPaymentEventForm,
    },
    async mounted () {
        this.$loading(true);

        if(this.FormType == 'Add'){
            this.EditableValue = false;
            this.DisabledInput = true;
            this.DisabledCustomerInput = true;

            if(window.$cookies.get('RoleName') == 'Distributor'){
                this.DisabledCustomerInput = false;
            }

            this.InvoiceCode = '';

            this.Type = '';
            this.Note = '';
            this.StatusData = [ {value: 'New', label: 'New'} ];
            this.Status = 'New';
            this.CustomerData = await invoiceDownPaymentService.getCustomerQuery();
            this.Customer = '';
            this.ProjectData = [];
            this.Project = '';

            this.PPNTaxData = await invoiceDownPaymentService.getDropdownPPNTax();
            
            //reset  pajak
            this.resetTax();

            //reset customer
            this.resetCustomerInfo();

            //reset project
            this.ProjectData = [];
            this.Project = '';
            this.resetProjectInfo();

            this.TotalGross = 0;
            this.TotalDisc = 0;
            this.TotalPPNTax = 0;
            this.GrandTotal = 0;

            //down payment
            this.DownPayment = 0;
            var dateNow = moment(new Date()).format("YYYY-MM-DD");
            this.DownPaymentDate = dateNow;
            this.DownPaymentNote = '';
            this.DownPaymentGridData = [];

            this.SaveType = 'Add';
            this.Customer = this.CustomerData.find(c => c.value == parseInt(window.$cookies.get('ContactID')));
            this.onChangeCustomer();
        }else{
            this.EditableValue = false;
            this.DisabledInput = false;
            this.DisabledCustomerInput = false;

            var data = await invoiceDownPaymentService.getInvoiceDownPaymentQuery(this.Id);
            var customer = await invoiceDownPaymentService.getContactDetailQuery({type : "Distributor", id : data.customer_id});
            var projectData = await invoiceDownPaymentService.getProjectDetail(data.project_id);

            this.InvoiceId = data.down_payment_id;
            this.InvoiceCode = data.down_payment_number;

            this.Type = projectData.project_type == 1 ? "Project" : "Retail";  
            this.Note = data.notes;
            this.StatusData = [ 
                {value: 'New', label: 'New'}, 
                {value: 'Finish', label: 'Finish'}, 
                {value: 'Cancel', label: 'Cancel'}
            ];
            this.Status = data.status;

            this.CustomerData = await invoiceDownPaymentService.getCustomerQuery();
            this.Customer = this.CustomerData.find(c => c.value == data.customer_id);
            this.ProjectData = await invoiceDownPaymentService.getProjectDropdownByCustomerId(this.Customer.value, this.Type);
            var projectSelected = this.ProjectData.find(c => c.value == data.project_id);
            this.Project = projectSelected == undefined ? {label : data.project_name, value : data.project_id} : projectSelected;

            this.PPNTaxData = await invoiceDownPaymentService.getDropdownPPNTax();
            this.PPNTax = data.tax_percentage;

            var customerData = customer.metadata;

            //Grid Item and Booking
            this.ItemGridData = invoiceDownPaymentService.editItemGridDataGenerator(data.transaction_down_payment_details);

            this.countTotalPO();

            //detail customer
            this.Deposit = 0;
            this.LimitPO = customerData.sale.po_limit;
            this.PONonCash = 0;
            this.Payment = 0;
            this.Outstanding = 0;
            this.RemainingLimit = customerData.sale.po_limit - parseFloat(customer.on_going_purchase_order_total_by_customer_id);

            //detail project
            var salesmanData = await invoiceDownPaymentService.getContactDetailQuery({type : "Employee", id : projectData.sales_id});
            this.ProjectSalesman = salesmanData.contact_name;
            this.ProjectForecastType = projectData.forecast_type;

            //down payment
            this.DownPayment = 0;
            this.DownPaymentDate = '';
            this.DownPaymentNote = '';
            this.DownPaymentGridData = data.transaction_down_payment_events;
            
            this.SaveType = 'Edit';

            if (data.status == 'New') {
                document.getElementById('InvoiceCode').readOnly = false;
            }

            if(this.View == 'true'){
                $(".save-button").hide();
            }
        }       
        this.$loading(false);
    },
    data(){
        return{
            FormType: this.$route.params.formtype,
            View: this.$route.params.view,
            Id: this.$route.params.id,

            InvoiceId: '',
            InvoiceCode: '',
            Type: '',
            PPNTaxData: [],
            PPNTax: 0,
            Note: '',
            Status: '',
            StatusData: [],
            Customer: '',
            CustomerData: [],
            Project: '',
            ProjectData: [],

            Deposit: 0,
            LimitPO: 0,
            PONonCash: 0,
            Payment: 0,
            Outstanding: 0,
            RemainingLimit: 0,

            ProjectSalesman: '',
            ProjectForecastType: '',

            TotalGross: 0,
            TotalDisc: 0,
            TotalPPNTax: 0,
            GrandTotal: 0,
            EditableValue: false,

            //grid
            ItemGridData: [],
            ItemSchemaModel: {
                product_code: { type: "string", editable: false },
                item_name: { type: "string", editable: false },
                price: { type: "number", editable: false },
                price_discount: { type: "number", editable: false },
                net: { type: "number", editable: false },
                qty: { type: "number", editable: false, validation: { min:0 } },
                real_qty: { type: "number", editable: false },
                total_price: { type: "number", editable: false },
                discount1: { type: "string", editable: false },
                discount2: { type: "string", editable: false },
                discount3: { type: "string", editable: false },
                discount4: { type: "string", editable: false },
                discount5: { type: "string", editable: false },
                discount_cash: { type: "string", editable: false },
            },

            //down payment
            DownPayment: 0,
            DownPaymentDate: '',
            DownPaymentNote: '',
            DownPaymentGridData: [],
            DownPaymentSchemaModel: {
                date: { type: "string", editable: false },
                amount: { type: "number", editable: false },
                notes: { type: "string", editable: false },
                created_by: { type: "string", editable: false }
            },

            //disable variable
            DisabledInput: true,
            DisabledCustomerInput: true,
        }
    },
    methods: {
        dateFormat(e){
            var date = kendo.toString(kendo.parseDate(e.date, 'yyyy-MM-dd'), 'yyyy-MM-dd');
            return date == null ? "" : date;
        },
        async onChangeCustomer(){
            if(this.Customer == null){
                //reset project
                this.ProjectData = [];
                this.Project = '';
                this.resetProjectInfo();
                this.resetCustomerInfo();
                this.resetTax();
            }else{
                // set address dropdown
                var data = await invoiceDownPaymentService.getContactDetailQuery({type : "Distributor", id : this.Customer.value});
                var customerData = data.metadata;

                //set tax by customer
                if(customerData.profile.taxfree){
                    this.PPNTax = 0;
                    document.getElementById('PPNTax').disabled = true;
                }else{
                    this.resetTax();
                }

                // reset project input
                this.ProjectData = await invoiceDownPaymentService.getProjectDropdownByCustomerId(this.Customer.value);
                this.Project = '';  
                this.resetProjectInfo();

                //detail customer
                this.Deposit = 0;
                this.LimitPO = customerData.sale.po_limit;
                this.PONonCash = 0;
                this.Payment = 0;
                this.Outstanding = 0;
                this.RemainingLimit = customerData.sale.po_limit - parseFloat(data.on_going_purchase_order_total_by_customer_id);
            }
            this.countTotalPO();
        },
        resetProjectInfo(){
            this.ItemGridData = [];
            this.ProjectSalesman = '';
            this.ProjectForecastType = '';
            this.Type = '';
        },
        resetCustomerInfo(){            
            //detail customer
            this.Deposit = 0;
            this.LimitPO = 0;
            this.PONonCash = 0;
            this.Payment = 0;
            this.Outstanding = 0;
            this.RemainingLimit = 0;
        },
        async resetTax(){
            if(this.$cookies.get('RoleName') == 'Distributor'){
                document.getElementById('PPNTax').disabled = true;
            }else{
                document.getElementById('PPNTax').disabled = false;
            }
            var ppnTax = await globalfunc.getPPNTax();
            this.PPNTax = ppnTax.label;
        },
        addDownPaymentClick(){
            var gridDownPayment = this.$refs.gridDownPayment.kendoWidget().dataSource._data;
            var totalDownPayment = invoiceDownPaymentService.getTotalDownPaymentEvent(gridDownPayment);
            this.$refs.downPaymentEventForm.addClick(this.InvoiceId, this.TotalGross, totalDownPayment);
        },
        countTotalPO(){
            var array = this.ItemGridData;
            var totalGross = 0;
            var totalDisc = 0;
            var totalPPNTax = 0;
            var totalGrossDisc = 0;
            var grandTotal = 0;

            if(array.length > 0){
                array.forEach(e => {
                    totalGross = totalGross + (e.price * e.qty);
                    totalDisc = totalDisc + (e.price_discount * e.qty);
                    totalGrossDisc = totalGrossDisc + (e.net * e.qty);
                    totalPPNTax = totalPPNTax + (e.net * (this.PPNTax / 100)) * e.qty;
                });
            }

            grandTotal = totalGrossDisc + Math.round(totalPPNTax);

            this.TotalGross = parseFloat(kendo.toString(totalGross, "0.00"));
            this.TotalDisc =  parseFloat(kendo.toString(totalDisc, "0.00"));
            this.TotalPPNTax = parseFloat(kendo.toString(Math.round(totalPPNTax), "0.00"));
            this.GrandTotal = parseFloat(kendo.toString(grandTotal ,"0.00"));
        }, 
        async onChangeProject(){
            if(this.Project == null){
                this.resetProjectInfo();
            }else{
                this.$loading(true);

                try {
                    this.ItemGridData = [];

                    var projectDetailData = await invoiceDownPaymentService.getProjectDetail(this.Project.value);
                    var salesmanData = await invoiceDownPaymentService.getContactDetailQuery({type : "Employee", id : projectDetailData.sales_id});
                    
                    this.ProjectSalesman = salesmanData.contact_name;
                    this.ProjectForecastType = projectDetailData.forecast_type;
                    this.Type = projectDetailData.project_type == 1 ? "Project" : "Retail";

                    this.addItemDetailToGrid();
                    this.$loading(false);
                } catch (error) {
                    this.$loading(false);
                    var errorMessage = globalfunc.errorExtractor(error)
                    this.$swal("Error", errorMessage, "error");
                }
            }
            this.countTotalPO();
        },
        itemCellClose(e){
        },
        disc1Template: function(e) {
            return kendo.format('{0:N0}', e.discount_amount_1) + ' ('+ e.discount1 + '%)';
        },
        disc2Template: function(e) {
            return kendo.format('{0:N0}', e.discount_amount_2) + ' ('+ e.discount2 + '%)';
        },
        disc3Template: function(e) {
            return kendo.format('{0:N0}', e.discount_amount_3) + ' ('+ e.discount3 + '%)';
        },
        disc4Template: function(e) {
            return kendo.format('{0:N0}', e.discount_amount_4) + ' ('+ e.discount4 + '%)';
        },
        disc5Template: function(e) {
            return kendo.format('{0:N0}', e.discount_amount_5) + ' ('+ e.discount5 + '%)';
        },
        disccashTemplate: function(e) {
            return kendo.format('{0:N0}', e.discount_amount_cash) + ' ('+ e.discount_cash + '%)';
        },
        saveDownPaymentGrid(){
           
        },
        async addItemDetailToGrid(){
            var itemDetailData = await invoiceDownPaymentService.getItemDetailData(this.Project.value);
            var itemDetailDataObject = invoiceDownPaymentService.itemDetailDataObject(itemDetailData, this.Type);
            this.ItemGridData = itemDetailDataObject;
            this.countTotalPO();
        },
        onChangePPNTax(){
            this.countTotalPO();
        },
        errorShow(errorCode, message){
            document.getElementById(errorCode).style.display = 'block';
            document.getElementById(errorCode).innerHTML = message == undefined ? response.fieldRequired : message;
            if(this.Error <= this.$globalvariable.max_error_focus){ document.getElementById(errorCode.replace("error", "")).focus(); }
            this.Error++;
        },
        inputValidation(){
            this.Error = 0;
            $(".form-error").css("display", "none");

            //Validation
            if(this.InvoiceCode == '' || this.InvoiceCode == null){
                this.errorShow('errorInvoiceCode');
            }
            if(this.Customer == '' || this.Customer == null){
                this.errorShow('errorCustomer');
            }
            if(this.Project == '' || this.Project == null){
                this.errorShow('errorProject');
            }

            //grid
            if(this.ItemGridData.length < 1 ){
                this.$swal("Error", "Item tidak boleh kosong", "error");
                this.Error++;
            }

            //downpayment
            if(this.FormType == 'Add'){
                if(this.DownPayment === '' || this.DownPayment == null){
                    this.errorShow('errorDownPayment');
                }
                if(this.DownPaymentDate == '' || this.DownPaymentDate == null){
                    this.errorShow('errorDownPaymentDate');
                }
            }
        },
        async saveClick(){
            this.inputValidation();

            //Proses
            if(this.Error == 0){
                if (this.SaveType == 'Add'){
                    this.$loading(true);

                    var gridItem = this.$refs.gridItem.kendoWidget().dataSource._data;
                    var piDetail = invoiceDownPaymentService.transactionInvoiceDownpaymentDetail(gridItem, this.PPNTax);
                    this.countTotalPO();
            
                    const piData = {
                        down_payment_number: this.InvoiceCode,
                        status: this.Status,
                        project_id: this.Project.value,
                        customer_id: this.Customer.value,
                        tax_percentage: this.PPNTax,
                        tax_amount: this.TotalPPNTax,
                        total: this.GrandTotal,
                        notes: this.Note,
                        transaction_down_payment_details: piDetail
                    }

                    const variables = {
                        data : piData
                    }
                    
                    invoiceDownPaymentService.addQuery(variables).then(res => {
                        const downPaymentData = {
                            down_payment_id: res.data.CreateTransactionDownPayment.down_payment_id,
                            date: this.DownPaymentDate,
                            amount: this.DownPayment,
                            notes: this.DownPaymentNote
                        }

                        const downPaymentVariables = {
                            data : downPaymentData
                        }

                        invoiceDownPaymentService.addEventQuery(downPaymentVariables).then(res => {
                            this.$loading(false);
                            this.$swal("Info", response.successSave, "success").then(
                                this.$router.push({ path: '/invoice-uang-muka' })
                            );
                        }).catch(error => {
                            this.$loading(false);
                            var errorMessage = globalfunc.errorExtractor(error)
                            this.$swal("Error", errorMessage, "error");
                        });
                    }).catch(error => {
                        this.$loading(false);
                        var errorMessage = globalfunc.errorExtractor(error)
                        this.$swal("Error", errorMessage, "error");
                    });
                }else if (this.SaveType == 'Edit'){
                    this.$loading(true);

                    const piData = {
                        CustomerID : this.Customer.value,
                        TaxPercentage : this.PPNTax,
                        TaxAmount : this.TotalPPNTax,
                        GrandTotal : this.GrandTotal,
                        Notes : this.Note,
                        Status : this.Status,
                        Confirmation : false
                    }

                    const variables = {
                        id : this.Id,
                        data : piData
                    }
                    
                    invoiceDownPaymentService.editQuery(variables).then(res => {
                        this.$loading(false);
                        this.$swal("Info", response.successUpdate, "success")
                            .then(res => {
                                if(res.isConfirmed == true || res.isDismissed == true){
                                    window.location = baseUrl + '/invoice-uang-muka'
                                }
                            });                  
                    }).catch(error => {
                        this.$loading(false);
                        var errorMessage = globalfunc.errorExtractor(error);
                        if(errorMessage == "confirmation is required (DS.UTDP.00)"){
                            this.$swal(sweet_alert.update_inline_grid)
                            .then(res => {
                                if(res.isConfirmed == true){
                                    // reupdate
                                    variables.data.Confirmation = true;

                                    invoiceDownPaymentService.editQuery(variables).then(res => {
                                        this.$loading(false);
                                        this.$swal("Info", response.successUpdate, "success")
                                            .then(res => {
                                                if(res.isConfirmed == true || res.isDismissed == true){
                                                    window.location = baseUrl + '/invoice-uang-muka'
                                                }
                                            });                  
                                    }).catch(error => {
                                        this.$loading(false);
                                        var errorMessage = globalfunc.errorExtractor(error);
                                        this.$swal("Error", errorMessage, "error");
                                    })
                                }
                            });   
                        }else{
                            this.$swal("Error", errorMessage, "error");
                        }
                    })
                }
            }
        }
    }
}
</script>

<style scoped>
.label-file {
  width : 100%;
  overflow:hidden;
  display:inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>